import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'Testimoni',
  type: 'manuscript',
  bodyClasses: 'mr-manuscript-custom',
  sections: {
    top: [
      // {
      //   id: 'breadcrumbs-witness',
      //   type: 'breadcrumbs',
      //   options: {
      //     base: [
      //       {
      //         title: 'global#home',
      //         link: '/'
      //       },
      //       {
      //         title: 'Fiore di virtù',
      //         link: '/progetto/1/placeholder-slug'
      //       }
      //     ]
      //   }
      // },
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            window: {
              sideBarOpenByDefault: false,
              allowClose: false,
              allowMaximize: true,
              defaultSideBarPanel: 'info',
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
              workspaceControlPanel: {
                enabled: false,
              },
            },
            id: 'mirador-container',
            workspace: {
              type: 'single',
            },
          },
        }
      },
      {
        id: 'parallel-text-viewer',
        type: 'parallel-text-viewer',
        options: {
          searchId: 'xml_text',
          grid: {
            panels: [0],
          },
          panels:[
            {
              id: "doc2",
              odd: "",
              view: "page",
            },
          ],
          libOptions: {
          pbPage: {
            urlIgnore: 
              [
                //  "highlight1,odd,view,path,selectors,highlight,view2"
              ],
          },
          toc: {
            disable: true,
          },
          grid: {
            disableAddColumn: true,
          }
        },
        },
      },
      {
        id: 'metadata',
        type: 'metadata',
      },
    ],
  },
} as ConfigMurucaResourceLayout;
